import { Module } from "wrapper6";

var $ = jQuery;

export default class QuickSignup extends Module {

	ready(app) {

		$(document).on('change', 'select#quick-signup-select', function(e){

			let select = jQuery(e.target);
			let url = select.find('option:selected').attr('data-post-url');
			window.location = url;

		});

    }
}